export const userProfile = require("../assets/user-profile.png");
